<div class="container-fluid">
    <div class="loading-container">
        <img src="/assets/images/loading.gif" alt="loading">
        <span>{{msg}}</span>
    </div>
</div>